import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class IframeCommunicationService {
    constructor() {}

    pageChange(url = 'changed') {
      setTimeout(() => {
        const page = document.querySelector('.page');
        if (page) page.setAttribute('style', 'min-height: unset');

        const height = this.getHeight();
        if (height) window.parent.postMessage({changePage: url, height}, '*')
      }, 1000);
    }

    contentChangedScrollBottom() {
      setTimeout(() => {
        const height = this.getHeight();
        if (height) window.parent.postMessage({changePage: 1, scrollEnd: true, height}, '*')
      }, 500);
    }

    getHeight() {
      const el = document.body.querySelector('.ng-trigger div');
      return el ? el.scrollHeight : 0;
    }
}
